const Playstore = ({ ...props }) => {
  return (
    <svg height="25" viewBox="0 0 143.459 42.507" {...props} xmlns="http://www.w3.org/2000/svg">
      <defs>
        <clipPath id="a">
          <path
            clipRule="evenodd"
            d="M10.543-6.058l-.079-.075a2.128,2.128,0,0,1-.492-1.493V-30.818a2.054,2.054,0,0,1,.57-1.571L23.708-19.224ZM9.972-30.981c0-.058,0-.116,0-.171C9.974-31.1,9.972-31.039,9.972-30.981Zm.005-.174v0Zm0-.007h0Z"
            fill="none"
            transform="translate(-9.972 32.389)"
          />
        </clipPath>
        <linearGradient
          gradientUnits="objectBoundingBox"
          id="b"
          x1="0.826"
          x2="1.017"
          y1="0.303"
          y2="0.303"
        >
          <stop offset="0" stopColor="#00a0ff" />
          <stop offset="0.1" stopColor="#00a6ff" />
          <stop offset="0.2" stopColor="#00adff" />
          <stop offset="0.3" stopColor="#00b3ff" />
          <stop offset="0.4" stopColor="#00baff" />
          <stop offset="0.5" stopColor="#00c1ff" />
          <stop offset="0.6" stopColor="#00c7ff" />
          <stop offset="0.7" stopColor="#00ceff" />
          <stop offset="0.8" stopColor="#00d4ff" />
          <stop offset="0.9" stopColor="#00dbff" />
          <stop offset="1" stopColor="#00e2ff" />
        </linearGradient>
        <clipPath id="c">
          <path
            clipRule="evenodd"
            d="M27.286-15.2l.1-.057,5.2-2.954a2.273,2.273,0,0,0,.991-.985,2.28,2.28,0,0,1-.991.986l-5.2,2.954Zm0-.156L22.9-19.741l4.389-4.389,5.3,3.011A1.974,1.974,0,0,1,33.7-19.741v0a1.978,1.978,0,0,1-1.114,1.377Z"
            fill="none"
            transform="translate(-22.898 24.13)"
          />
        </clipPath>
        <linearGradient
          gradientUnits="objectBoundingBox"
          id="d"
          x1="0.749"
          x2="0.929"
          y1="0.5"
          y2="0.5"
        >
          <stop offset="0" stopColor="#ffde00" />
          <stop offset="0.1" stopColor="#ffd800" />
          <stop offset="0.2" stopColor="#ffd100" />
          <stop offset="0.3" stopColor="#ffca00" />
          <stop offset="0.4" stopColor="#ffc400" />
          <stop offset="0.5" stopColor="#ffbd00" />
          <stop offset="0.6" stopColor="#ffb600" />
          <stop offset="0.7" stopColor="#ffb000" />
          <stop offset="0.8" stopColor="#ffa900" />
          <stop offset="0.9" stopColor="#ffa200" />
          <stop offset="1" stopColor="#ff9c00" />
        </linearGradient>
        <clipPath id="e">
          <path
            clipRule="evenodd"
            d="M11.452-6.333a1.37,1.37,0,0,1-.938-.345h0a1.368,1.368,0,0,0,.939.346c.032,0,.065,0,.1,0Q11.5-6.333,11.452-6.333Zm0-.156a1.363,1.363,0,0,1-.939-.345L23.679-20l4.389,4.39L12.643-6.845A2.441,2.441,0,0,1,11.453-6.489Zm-.943-.192c-.023-.021-.047-.044-.069-.067Z"
            fill="none"
            transform="translate(-10.441 20)"
          />
        </clipPath>
        <linearGradient
          gradientUnits="objectBoundingBox"
          id="f"
          x1="0.731"
          x2="0.991"
          y1="0.243"
          y2="0.243"
        >
          <stop offset="0" stopColor="#ff3a44" />
          <stop offset="0.1" stopColor="#f83547" />
          <stop offset="0.2" stopColor="#f2314a" />
          <stop offset="0.3" stopColor="#ec2d4d" />
          <stop offset="0.4" stopColor="#e62950" />
          <stop offset="0.5" stopColor="#e02553" />
          <stop offset="0.6" stopColor="#da2156" />
          <stop offset="0.7" stopColor="#d41d59" />
          <stop offset="0.8" stopColor="#ce195b" />
          <stop offset="0.9" stopColor="#c8155e" />
          <stop offset="1" stopColor="#c21161" />
        </linearGradient>
        <clipPath id="g">
          <path
            clipRule="evenodd"
            d="M23.674-19.194,10.508-32.359a1.37,1.37,0,0,1,.938-.345,2.441,2.441,0,0,1,1.192.358l15.424,8.764Zm4.488-4.488L12.639-32.5a2.441,2.441,0,0,0-1.192-.358h0a2.446,2.446,0,0,1,1.191.357l15.523,8.82Z"
            fill="none"
            transform="translate(-10.508 32.86)"
          />
        </clipPath>
        <linearGradient
          gradientUnits="objectBoundingBox"
          id="h"
          x1="0.269"
          x2="0.385"
          y1="0.043"
          y2="0.043"
        >
          <stop offset="0" stopColor="#31a06f" />
          <stop offset="0.1" stopColor="#2ca770" />
          <stop offset="0.2" stopColor="#27af70" />
          <stop offset="0.3" stopColor="#22b771" />
          <stop offset="0.4" stopColor="#1dbf71" />
          <stop offset="0.5" stopColor="#18c772" />
          <stop offset="0.6" stopColor="#13cf72" />
          <stop offset="0.7" stopColor="#0ed773" />
          <stop offset="0.8" stopColor="#09df73" />
          <stop offset="0.9" stopColor="#04e774" />
          <stop offset="1" stopColor="#00ef74" />
        </linearGradient>
        <clipPath id="i">
          <path
            clipRule="evenodd"
            d="M27.027-15.719l.1-.057Z"
            fill="none"
            transform="translate(-27.027 15.776)"
          />
        </clipPath>
        <linearGradient
          gradientUnits="objectBoundingBox"
          id="j"
          x1="0.749"
          x2="0.929"
          y1="0.5"
          y2="0.5"
        >
          <stop offset="0" stopColor="#ccb300" />
          <stop offset="0.1" stopColor="#ccad00" />
          <stop offset="0.2" stopColor="#cca800" />
          <stop offset="0.3" stopColor="#cca200" />
          <stop offset="0.4" stopColor="#cc9d00" />
          <stop offset="0.5" stopColor="#cc9700" />
          <stop offset="0.6" stopColor="#cc9200" />
          <stop offset="0.7" stopColor="#cc8c00" />
          <stop offset="0.8" stopColor="#cc8700" />
          <stop offset="0.9" stopColor="#cc8100" />
          <stop offset="1" stopColor="#cc7c00" />
        </linearGradient>
        <clipPath id="k">
          <path
            clipRule="evenodd"
            d="M11.453-6.592a1.368,1.368,0,0,1-.939-.346h0l0,0-.069-.067-.006-.006.079-.08a1.363,1.363,0,0,0,.939.345,2.44,2.44,0,0,0,1.19-.356l15.424-8.765.1.1-.1.057L12.643-6.949a2.544,2.544,0,0,1-1.092.354C11.518-6.593,11.485-6.592,11.453-6.592Z"
            fill="none"
            transform="translate(-10.435 15.869)"
          />
        </clipPath>
        <linearGradient
          gradientUnits="objectBoundingBox"
          id="l"
          x1="0.731"
          x2="0.991"
          y1="0.243"
          y2="0.243"
        >
          <stop offset="0" stopColor="#cc2d36" />
          <stop offset="0.1" stopColor="#c72938" />
          <stop offset="0.2" stopColor="#c2263a" />
          <stop offset="0.3" stopColor="#bd233c" />
          <stop offset="0.4" stopColor="#b8203f" />
          <stop offset="0.5" stopColor="#b41d41" />
          <stop offset="0.6" stopColor="#af1a43" />
          <stop offset="0.7" stopColor="#aa1746" />
          <stop offset="0.8" stopColor="#a51448" />
          <stop offset="0.9" stopColor="#a0114a" />
          <stop offset="1" stopColor="#9c0d4d" />
        </linearGradient>
        <clipPath id="m">
          <path
            clipRule="evenodd"
            d="M10.464-7.44a2.124,2.124,0,0,1-.492-1.493v-.154a2.128,2.128,0,0,0,.492,1.493l.079.075Z"
            fill="none"
            transform="translate(-9.972 9.087)"
          />
        </clipPath>
        <linearGradient
          gradientUnits="objectBoundingBox"
          id="n"
          x1="0.826"
          x2="1.017"
          y1="0.303"
          y2="0.303"
        >
          <stop offset="0" stopColor="#008bde" />
          <stop offset="0.1" stopColor="#0091de" />
          <stop offset="0.2" stopColor="#0097de" />
          <stop offset="0.3" stopColor="#009dde" />
          <stop offset="0.4" stopColor="#00a3de" />
          <stop offset="0.5" stopColor="#00a9de" />
          <stop offset="0.6" stopColor="#00aede" />
          <stop offset="0.7" stopColor="#00b4de" />
          <stop offset="0.8" stopColor="#00bade" />
          <stop offset="0.9" stopColor="#00c0de" />
          <stop offset="1" stopColor="#00c6de" />
        </linearGradient>
        <clipPath id="o">
          <path
            clipRule="evenodd"
            d="M10.435-7.531h0l.079-.079Z"
            fill="none"
            transform="translate(-10.435 7.611)"
          />
        </clipPath>
        <linearGradient
          gradientUnits="objectBoundingBox"
          id="p"
          x1="0.731"
          x2="0.991"
          y1="0.243"
          y2="0.243"
        >
          <stop offset="0" stopColor="#de333b" />
          <stop offset="0.1" stopColor="#d92f3d" />
          <stop offset="0.2" stopColor="#d42b40" />
          <stop offset="0.3" stopColor="#cf2743" />
          <stop offset="0.4" stopColor="#c92445" />
          <stop offset="0.5" stopColor="#c42048" />
          <stop offset="0.6" stopColor="#bf1c4b" />
          <stop offset="0.7" stopColor="#b9194d" />
          <stop offset="0.8" stopColor="#b41550" />
          <stop offset="0.9" stopColor="#af1153" />
          <stop offset="1" stopColor="#aa0d56" />
        </linearGradient>
        <clipPath id="q">
          <path
            clipRule="evenodd"
            d="M27.127-15.511l-.1-.1,5.3-3.011A1.978,1.978,0,0,0,33.44-20a1.309,1.309,0,0,1-.122.547,2.273,2.273,0,0,1-.991.985Z"
            fill="none"
            transform="translate(-27.028 19.998)"
          />
        </clipPath>
        <linearGradient
          gradientUnits="objectBoundingBox"
          id="r"
          x1="0.749"
          x2="0.929"
          y1="0.5"
          y2="0.5"
        >
          <stop offset="0" stopColor="#dec300" />
          <stop offset="0.1" stopColor="#debe00" />
          <stop offset="0.2" stopColor="#deb800" />
          <stop offset="0.3" stopColor="#deb200" />
          <stop offset="0.4" stopColor="#deac00" />
          <stop offset="0.5" stopColor="#dea600" />
          <stop offset="0.6" stopColor="#dea000" />
          <stop offset="0.7" stopColor="#de9a00" />
          <stop offset="0.8" stopColor="#de9400" />
          <stop offset="0.9" stopColor="#de8e00" />
          <stop offset="1" stopColor="#de8900" />
        </linearGradient>
        <clipPath id="s">
          <path
            clipRule="evenodd"
            d="M33.44-19.735a1.974,1.974,0,0,0-1.114-1.378l-5.3-3.011.1-.1,5.2,2.954A1.863,1.863,0,0,1,33.44-19.735Z"
            fill="none"
            transform="translate(-27.028 24.223)"
          />
        </clipPath>
        <linearGradient
          gradientUnits="objectBoundingBox"
          id="t"
          x1="0.749"
          x2="0.929"
          y1="0.5"
          y2="0.5"
        >
          <stop offset="0" stopColor="#ffe73f" />
          <stop offset="0.1" stopColor="#ffe23f" />
          <stop offset="0.2" stopColor="#ffdd3f" />
          <stop offset="0.3" stopColor="#ffd83f" />
          <stop offset="0.4" stopColor="#ffd33f" />
          <stop offset="0.5" stopColor="#ffce3f" />
          <stop offset="0.6" stopColor="#ffc93f" />
          <stop offset="0.7" stopColor="#ffc43f" />
          <stop offset="0.8" stopColor="#ffbf3f" />
          <stop offset="0.9" stopColor="#ffba3f" />
          <stop offset="1" stopColor="#ffb43f" />
        </linearGradient>
        <clipPath id="u">
          <path
            clipRule="evenodd"
            d="M9.972-30.809v-.163c0-.058,0-.116,0-.171a0,0,0,0,0,0,0v-.008a2.028,2.028,0,0,1,.487-1.3l.078.079A2.054,2.054,0,0,0,9.972-30.809Zm.567-1.723,0,0Z"
            fill="none"
            transform="translate(-9.972 32.535)"
          />
        </clipPath>
        <linearGradient
          gradientUnits="objectBoundingBox"
          id="v"
          x1="0.826"
          x2="1.017"
          y1="0.303"
          y2="0.303"
        >
          <stop offset="0" stopColor="#3fb8ff" />
          <stop offset="0.1" stopColor="#3fbcff" />
          <stop offset="0.2" stopColor="#3fc1ff" />
          <stop offset="0.3" stopColor="#3fc6ff" />
          <stop offset="0.4" stopColor="#3fcbff" />
          <stop offset="0.5" stopColor="#3fd0ff" />
          <stop offset="0.6" stopColor="#3fd5ff" />
          <stop offset="0.7" stopColor="#3fdaff" />
          <stop offset="0.8" stopColor="#3fdfff" />
          <stop offset="0.9" stopColor="#3fe4ff" />
          <stop offset="1" stopColor="#3fe8ff" />
        </linearGradient>
        <clipPath id="w">
          <path
            clipRule="evenodd"
            d="M28.068-23.583,12.643-32.347a2.441,2.441,0,0,0-1.192-.358,1.37,1.37,0,0,0-.938.345l-.078-.079c.024-.026.05-.05.075-.073l0,0a1.365,1.365,0,0,1,.929-.345h.009a2.441,2.441,0,0,1,1.192.358l15.523,8.82Z"
            fill="none"
            transform="translate(-10.435 32.86)"
          />
        </clipPath>
        <linearGradient
          gradientUnits="objectBoundingBox"
          id="x"
          x1="0.269"
          x2="0.385"
          y1="0.043"
          y2="0.043"
        >
          <stop offset="0" stopColor="#64b894" />
          <stop offset="0.1" stopColor="#60be95" />
          <stop offset="0.2" stopColor="#5cc495" />
          <stop offset="0.3" stopColor="#58ca95" />
          <stop offset="0.4" stopColor="#55d095" />
          <stop offset="0.5" stopColor="#51d696" />
          <stop offset="0.6" stopColor="#4ddc96" />
          <stop offset="0.7" stopColor="#4ae296" />
          <stop offset="0.8" stopColor="#46e896" />
          <stop offset="0.9" stopColor="#42ee96" />
          <stop offset="1" stopColor="#3ff497" />
        </linearGradient>
      </defs>
      <g transform="translate(0 40.001)">
        <path
          d="M138.146,2.505H5.313A5.329,5.329,0,0,1,0-2.808v-31.88A5.329,5.329,0,0,1,5.313-40H138.146a5.329,5.329,0,0,1,5.313,5.313v31.88A5.329,5.329,0,0,1,138.146,2.505Z"
          transform="translate(0 0)"
        />
        <path
          d="M138.146-40H5.313A5.329,5.329,0,0,0,0-34.688V-2.807A5.33,5.33,0,0,0,5.313,2.506H138.146a5.33,5.33,0,0,0,5.313-5.313V-34.688A5.329,5.329,0,0,0,138.146-40Zm0,.849a4.469,4.469,0,0,1,4.463,4.463V-2.807a4.469,4.469,0,0,1-4.463,4.463H5.313A4.469,4.469,0,0,1,.85-2.807V-34.688a4.469,4.469,0,0,1,4.463-4.463Z"
          fill="#a6a6a6"
          transform="translate(0 0)"
        />
        <path
          d="M47.8-29.545a2.878,2.878,0,0,1-.792,2.129,3.1,3.1,0,0,1-2.342.943,3.209,3.209,0,0,1-2.346-.956,3.205,3.205,0,0,1-.966-2.374,3.2,3.2,0,0,1,.966-2.373,3.206,3.206,0,0,1,2.346-.957,3.278,3.278,0,0,1,1.308.268,2.637,2.637,0,0,1,1,.712l-.561.561a2.151,2.151,0,0,0-1.745-.757,2.425,2.425,0,0,0-1.742.708,2.438,2.438,0,0,0-.734,1.838,2.439,2.439,0,0,0,.734,1.839,2.425,2.425,0,0,0,1.742.708,2.418,2.418,0,0,0,1.781-.712,2,2,0,0,0,.533-1.291H44.664v-.766h3.089A2.733,2.733,0,0,1,47.8-29.545Z"
          fill="#fff"
          transform="translate(2.591 0.43)"
        />
        <path
          d="M47.911-29.539H47.7a2.771,2.771,0,0,1-.761,2.053h0a2.986,2.986,0,0,1-2.266.91A3.1,3.1,0,0,1,42.4-27.5a3.1,3.1,0,0,1-.934-2.3,3.1,3.1,0,0,1,.934-2.3,3.1,3.1,0,0,1,2.272-.927,3.171,3.171,0,0,1,1.267.259,2.527,2.527,0,0,1,.957.682l.082-.068-.075-.075-.56.561.074.075.082-.068a2.258,2.258,0,0,0-1.827-.795,2.527,2.527,0,0,0-1.815.737,2.545,2.545,0,0,0-.767,1.915,2.546,2.546,0,0,0,.767,1.916,2.527,2.527,0,0,0,1.815.737,2.524,2.524,0,0,0,1.855-.743,2.115,2.115,0,0,0,.565-1.358l.011-.115H44.777v-.554H47.76v-.106l-.1.019a2.615,2.615,0,0,1,.043.462h.213a2.743,2.743,0,0,0-.047-.5l-.015-.087H44.564v.979h2.421v-.106l-.105-.01a1.9,1.9,0,0,1-.5,1.225,2.311,2.311,0,0,1-1.706.681A2.313,2.313,0,0,1,43-28.035a2.331,2.331,0,0,1-.7-1.763A2.33,2.33,0,0,1,43-31.56a2.313,2.313,0,0,1,1.667-.678,2.046,2.046,0,0,1,1.664.718l.074.089.642-.643.069-.069-.063-.074a2.738,2.738,0,0,0-1.036-.742,3.4,3.4,0,0,0-1.351-.276,3.317,3.317,0,0,0-2.422.988,3.315,3.315,0,0,0-1,2.448,3.319,3.319,0,0,0,1,2.449,3.317,3.317,0,0,0,2.422.987,3.2,3.2,0,0,0,2.419-.976l-.076-.073.075.074A2.983,2.983,0,0,0,47.911-29.539Z"
          fill="#fff"
          transform="translate(2.585 0.424)"
        />
        <path
          d="M52.247-32.217h-2.9V-30.2h2.618v.766H49.343v2.021h2.9v.783H48.524V-33h3.722Z"
          fill="#fff"
          transform="translate(3.04 0.439)"
        />
        <path
          d="M52.253-32.21v-.106H49.243v2.234h2.618v.554H49.243V-27.3h2.9v.571h-3.51v-6.163h3.51v.678h.106v0h.106V-33.1H48.424v6.588h3.935v-1h-2.9v-1.809h2.618V-30.3H49.456V-32.1h2.9v-.106Z"
          fill="#fff"
          transform="translate(3.034 0.432)"
        />
        <path
          d="M55.431-26.625h-.819v-5.592H52.831V-33h4.381v.784H55.431Z"
          fill="#fff"
          transform="translate(3.31 0.439)"
        />
        <path
          d="M55.438-26.619v-.106h-.713v-5.592H52.944v-.572h4.169v.572H55.331v5.7h.106v0h.106V-32.1h1.781v-1H52.731v1h1.781v5.592h1.032v-.106Z"
          fill="#fff"
          transform="translate(3.304 0.432)"
        />
        <path d="M59.938-26.625h.818V-33h-.818Z" fill="#fff" transform="translate(3.756 0.439)" />
        <path
          d="M59.944-26.619h.106v-6.27h.606v6.163h-.712v.106h0v.106h.925V-33.1H59.838v6.588h.106Z"
          fill="#fff"
          transform="translate(3.749 0.432)"
        />
        <path
          d="M64.281-26.625h-.82v-5.592h-1.78V-33h4.381v.784H64.281Z"
          fill="#fff"
          transform="translate(3.865 0.439)"
        />
        <path
          d="M64.288-26.619v-.106h-.714v-5.592h-1.78v-.572h4.169v.572H64.181v5.7h.106v0h.106V-32.1h1.781v-1H61.581v1h1.78v5.592h1.033v-.106Z"
          fill="#fff"
          transform="translate(3.859 0.432)"
        />
        <path
          d="M69.87-27.974a2.342,2.342,0,0,0,1.732.716,2.344,2.344,0,0,0,1.732-.716,2.5,2.5,0,0,0,.709-1.831,2.5,2.5,0,0,0-.709-1.83,2.344,2.344,0,0,0-1.732-.716,2.342,2.342,0,0,0-1.732.716,2.5,2.5,0,0,0-.708,1.83A2.5,2.5,0,0,0,69.87-27.974Zm4.07.533a3.126,3.126,0,0,1-2.338.966,3.121,3.121,0,0,1-2.337-.966,3.26,3.26,0,0,1-.939-2.364,3.258,3.258,0,0,1,.939-2.363,3.122,3.122,0,0,1,2.337-.967,3.127,3.127,0,0,1,2.334.971,3.259,3.259,0,0,1,.944,2.359A3.265,3.265,0,0,1,73.94-27.44Z"
          fill="#fff"
          transform="translate(4.281 0.43)"
        />
        <path
          d="M69.876-27.967l-.075.074a2.446,2.446,0,0,0,1.808.748,2.446,2.446,0,0,0,1.808-.748,2.6,2.6,0,0,0,.74-1.905,2.6,2.6,0,0,0-.74-1.9,2.446,2.446,0,0,0-1.808-.748A2.446,2.446,0,0,0,69.8-31.7a2.6,2.6,0,0,0-.739,1.9,2.6,2.6,0,0,0,.739,1.905l.075-.074.075-.075a2.39,2.39,0,0,1-.677-1.756,2.394,2.394,0,0,1,.677-1.756h0a2.232,2.232,0,0,1,1.657-.685,2.232,2.232,0,0,1,1.656.684h0a2.383,2.383,0,0,1,.679,1.754,2.384,2.384,0,0,1-.679,1.756,2.229,2.229,0,0,1-1.656.685,2.232,2.232,0,0,1-1.657-.685Zm4.147.608-.153-.149a3.019,3.019,0,0,1-2.261.934,3.017,3.017,0,0,1-2.261-.934l0,0,0,0a3.152,3.152,0,0,1-.909-2.29,3.152,3.152,0,0,1,.909-2.289,3.018,3.018,0,0,1,2.261-.935,3.015,3.015,0,0,1,2.257.939,3.148,3.148,0,0,1,.914,2.285,3.158,3.158,0,0,1-.91,2.29l.153.149a3.374,3.374,0,0,0,.969-2.439,3.368,3.368,0,0,0-.973-2.433,3.238,3.238,0,0,0-2.41-1,3.233,3.233,0,0,0-2.413,1,3.365,3.365,0,0,0-.969,2.438A3.366,3.366,0,0,0,69.2-27.36l0,0,0,0a3.232,3.232,0,0,0,2.413,1A3.238,3.238,0,0,0,74.023-27.36Z"
          fill="#fff"
          transform="translate(4.275 0.424)"
        />
        <path
          d="M75.575-26.625V-33h1l3.1,4.96h.035l-.035-1.228V-33h.82v6.376h-.855l-3.242-5.2h-.035l.035,1.228v3.971Z"
          fill="#fff"
          transform="translate(4.735 0.439)"
        />
        <path
          d="M75.581-26.619h.106v-6.27h.832l3.1,4.96h.2l-.038-1.337v-3.624h.608v6.163H79.7l-3.242-5.2h-.2l.038,1.337v3.863h-.712v.106h0v.106h.925v-4.078l-.035-1.231-.106,0v.106H76.4v-.106l-.09.056,3.274,5.25H80.6V-33.1H79.571v3.839l.035,1.231.106,0v-.106h-.035v.106l.09-.056-3.13-5.01H75.475v6.588h.106Z"
          fill="#fff"
          transform="translate(4.729 0.432)"
        />
        <path
          d="M111.065-9.188h1.983V-22.474h-1.983Zm17.86-8.5-2.273,5.76h-.068l-2.359-5.76h-2.136l3.538,8.051L123.61-5.161h2.069l5.451-12.528ZM117.68-10.7c-.65,0-1.556-.324-1.556-1.127,0-1.025,1.129-1.419,2.1-1.419a3.535,3.535,0,0,1,1.812.444A2.4,2.4,0,0,1,117.68-10.7Zm.239-7.28a3.722,3.722,0,0,0-3.538,2.034l1.76.735a1.878,1.878,0,0,1,1.812-.974,1.909,1.909,0,0,1,2.085,1.709v.137a4.384,4.384,0,0,0-2.068-.513c-1.9,0-3.829,1.042-3.829,2.991a3.07,3.07,0,0,0,3.3,2.922,2.8,2.8,0,0,0,2.53-1.3h.068v1.025h1.914V-14.3C121.952-16.663,120.192-17.979,117.919-17.979Zm-12.255,1.907h-2.82v-4.553h2.82a2.3,2.3,0,0,1,2.324,2.277A2.313,2.313,0,0,1,105.664-16.071Zm-.051-6.4h-4.751V-9.188h1.982v-5.034h2.769a4.209,4.209,0,0,0,4.358-4.125A4.209,4.209,0,0,0,105.613-22.474ZM79.7-10.7a2.6,2.6,0,0,1-2.516-2.723A2.614,2.614,0,0,1,79.7-16.173a2.547,2.547,0,0,1,2.414,2.755A2.526,2.526,0,0,1,79.7-10.7Zm2.277-6.248h-.068a3.132,3.132,0,0,0-2.38-1.011A4.5,4.5,0,0,0,75.2-13.418a4.476,4.476,0,0,0,4.331,4.5,3.085,3.085,0,0,0,2.38-1.027h.068v.65c0,1.729-.925,2.653-2.414,2.653A2.5,2.5,0,0,1,77.29-8.247l-1.729.718a4.306,4.306,0,0,0,4.005,2.672c2.329,0,4.3-1.37,4.3-4.709V-17.68H81.981Zm3.253,7.755H87.22V-22.474H85.234Zm4.914-4.383a2.479,2.479,0,0,1,2.362-2.636,1.749,1.749,0,0,1,1.678.96Zm6.163-1.506a4.2,4.2,0,0,0-3.869-2.877,4.3,4.3,0,0,0-4.263,4.519,4.422,4.422,0,0,0,4.485,4.519,4.5,4.5,0,0,0,3.767-2L94.89-11.945a2.581,2.581,0,0,1-2.226,1.25,2.3,2.3,0,0,1-2.191-1.37l6.043-2.5Zm-48.148-1.49v1.917h4.589a4,4,0,0,1-1.045,2.414,4.7,4.7,0,0,1-3.544,1.4,5.035,5.035,0,0,1-5.033-5.1,5.035,5.035,0,0,1,5.033-5.1,4.893,4.893,0,0,1,3.459,1.37l1.352-1.353a6.687,6.687,0,0,0-4.811-1.934,7.117,7.117,0,0,0-7.122,7.019,7.117,7.117,0,0,0,7.122,7.019,6.418,6.418,0,0,0,4.9-1.968,6.339,6.339,0,0,0,1.661-4.485,6.291,6.291,0,0,0-.1-1.2ZM59.936-10.7a2.614,2.614,0,0,1-2.55-2.74,2.6,2.6,0,0,1,2.55-2.738,2.6,2.6,0,0,1,2.55,2.738A2.614,2.614,0,0,1,59.936-10.7Zm0-7.259A4.455,4.455,0,0,0,55.4-13.435a4.465,4.465,0,0,0,4.536,4.519,4.465,4.465,0,0,0,4.536-4.519A4.455,4.455,0,0,0,59.936-17.954Zm9.9,7.259a2.615,2.615,0,0,1-2.55-2.74,2.6,2.6,0,0,1,2.55-2.738,2.6,2.6,0,0,1,2.551,2.738A2.615,2.615,0,0,1,69.833-10.7Zm0-7.259A4.455,4.455,0,0,0,65.3-13.435a4.465,4.465,0,0,0,4.536,4.519,4.465,4.465,0,0,0,4.538-4.519A4.455,4.455,0,0,0,69.833-17.954Z"
          fill="#fff"
          transform="translate(2.572 1.068)"
        />
        <g clipPath="url(#a)" transform="translate(10.597 -31.912)">
          <g transform="translate(61.133 106.148) rotate(-135)">
            <path
              d="M131.5,30.057,30.057,131.5,0,101.441,101.441,0Z"
              fill="url(#b)"
              transform="translate(0 0)"
            />
          </g>
        </g>
        <g clipPath="url(#c)" transform="translate(24.333 -23.136)">
          <g transform="translate(119.126 25.642) rotate(180)">
            <path d="M143.459,42.507H0V0H143.459Z" fill="url(#d)" transform="translate(0 0)" />
          </g>
        </g>
        <g clipPath="url(#e)" transform="translate(11.095 -18.747)">
          <g transform="translate(60.634 92.983) rotate(-135)">
            <path
              d="M131.5,30.057,30.057,131.5,0,101.441,101.441,0Z"
              fill="url(#f)"
              transform="translate(0 0)"
            />
          </g>
        </g>
        <g clipPath="url(#g)" transform="translate(11.166 -32.413)">
          <g transform="translate(-32.42 13.665) rotate(-45)">
            <path
              d="M30.057,0,131.5,101.441,101.441,131.5,0,30.057Z"
              fill="url(#h)"
              transform="translate(0 0)"
            />
          </g>
        </g>
        <path
          d="M11.551-6.6a2.544,2.544,0,0,0,1.092-.354l15.423-8.764L12.643-6.958A2.516,2.516,0,0,1,11.551-6.6Zm-1.037-.342,0,0Zm-.072-.07-.006-.006Z"
          transform="translate(0.654 1.521)"
        />
        <g clipPath="url(#i)" transform="translate(28.72 -14.258)">
          <g transform="translate(114.738 16.765) rotate(180)">
            <path d="M143.459,42.507H0V0H143.459Z" fill="url(#j)" transform="translate(0 0)" />
          </g>
        </g>
        <g clipPath="url(#k)" transform="translate(11.089 -14.357)">
          <g transform="translate(60.641 88.593) rotate(-135)">
            <path
              d="M131.5,30.057,30.057,131.5,0,101.441,101.441,0Z"
              fill="url(#l)"
              transform="translate(0 0)"
            />
          </g>
        </g>
        <path
          d="M10.464-7.448a2.128,2.128,0,0,1-.492-1.493h0a2.124,2.124,0,0,0,.492,1.493Z"
          transform="translate(0.625 1.946)"
        />
        <g clipPath="url(#m)" transform="translate(10.597 -7.15)">
          <g transform="translate(61.133 81.386) rotate(-135)">
            <path
              d="M131.5,30.057,30.057,131.5,0,101.441,101.441,0Z"
              fill="url(#n)"
              transform="translate(0 0)"
            />
          </g>
        </g>
        <g clipPath="url(#o)" transform="translate(11.089 -5.581)">
          <g transform="translate(60.641 79.817) rotate(-135)">
            <path
              d="M131.5,30.057,30.057,131.5,0,101.441,101.441,0Z"
              fill="url(#p)"
              transform="translate(0 0)"
            />
          </g>
        </g>
        <path
          d="M32.947-19.451A1.309,1.309,0,0,0,33.069-20a0,0,0,0,1,0,0A1.315,1.315,0,0,1,32.947-19.451Z"
          transform="translate(2.064 1.253)"
        />
        <g clipPath="url(#q)" transform="translate(28.722 -18.745)">
          <g transform="translate(114.737 21.251) rotate(180)">
            <path d="M143.459,42.507H0V0H143.459Z" fill="url(#r)" transform="translate(0 0)" />
          </g>
        </g>
        <path
          d="M33.435-19.735h0a1.863,1.863,0,0,0-1.114-1.533l-5.2-2.954h0l5.2,2.955A1.865,1.865,0,0,1,33.435-19.735Z"
          fill="#404040"
          transform="translate(1.699 0.989)"
        />
        <g clipPath="url(#s)" transform="translate(28.722 -23.234)">
          <g transform="translate(114.737 25.741) rotate(180)">
            <path d="M143.459,42.507H0V0H143.459Z" fill="url(#t)" transform="translate(0 0)" />
          </g>
        </g>
        <path
          d="M9.972-30.95h0Zm0-.172a0,0,0,0,0,0,0A0,0,0,0,1,9.976-31.123Zm0-.005v-.005Zm0-.006c.062-1.091.655-1.722,1.494-1.726a1.365,1.365,0,0,0-.929.345l0,0c-.026.023-.051.048-.075.073A2.028,2.028,0,0,0,9.977-31.134Z"
          fill="#404040"
          transform="translate(0.625 0.447)"
        />
        <g clipPath="url(#u)" transform="translate(10.597 -32.067)">
          <g transform="translate(61.133 106.303) rotate(-135)">
            <path
              d="M131.5,30.057,30.057,131.5,0,101.441,101.441,0Z"
              fill="url(#v)"
              transform="translate(0 0)"
            />
          </g>
        </g>
        <g clipPath="url(#w)" transform="translate(11.089 -32.413)">
          <g transform="translate(-32.343 13.665) rotate(-45)">
            <path
              d="M30.057,0,131.5,101.441,101.441,131.5,0,30.057Z"
              fill="url(#x)"
              transform="translate(0 0)"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export default Playstore;
